// Due to metric cardinality we only surface a subset of Cloudflare cache statuses
export type CacheStatus = 'hit' | 'miss' | 'other' | 'unknown'

// https://developers.cloudflare.com/cache/concepts/cache-responses/
type CloudflareCacheStatus =
  | 'hit'
  | 'miss'
  | 'expired'
  | 'stale'
  // "NONE/UNKNOWN" in the docs
  | 'null'
  | 'bypass'
  | 'revalidated'
  | 'updated'
  | 'dynamic'

/**
 * Reads the Cloudflare cache status from the `<meta name="cachestatus">` tag
 * injected by our edge worker. Returns 'hit'/'miss' verbatim, collapses every
 * other valid status into 'other', and returns 'unknown' if the tag is missing.
 */
export function getCacheStatus(): CacheStatus {
  const allowedStatuses = ['hit', 'miss']
  const cloudflareCacheStatus: CloudflareCacheStatus | undefined | null =
    document
      .querySelector('meta[name="cachestatus"]')
      ?.getAttribute('content') as CloudflareCacheStatus | null

  if (
    typeof cloudflareCacheStatus === 'string' &&
    cloudflareCacheStatus.trim() !== ''
  ) {
    if (allowedStatuses.includes(cloudflareCacheStatus)) {
      return cloudflareCacheStatus as CacheStatus
    }

    return 'other'
  }

  return 'unknown'
}
